export default __webpack_public_path__ + "static/media/logo.5792918e.svg";